(function () {
  var body = document.body;
  var themeI18n = parseJsonScript(document.querySelector("[data-theme-i18n]")) || {};

  function i18n(key, fallback) {
    if (themeI18n && Object.prototype.hasOwnProperty.call(themeI18n, key) && themeI18n[key] !== "") {
      return themeI18n[key];
    }
    return fallback;
  }

  function parseJsonScript(node) {
    if (!node) return null;
    try {
      return JSON.parse(node.textContent || "{}");
    } catch (error) {
      return null;
    }
  }

  function sanitizeQty(value) {
    var parsed = parseInt(value, 10);
    if (!Number.isFinite(parsed) || parsed < 1) return 1;
    return Math.min(parsed, 99);
  }

  function isMotorcycleCollectionContext() {
    var pathname = String(window.location.pathname || "").toLowerCase();
    var search = new URLSearchParams(window.location.search || "");
    var typeFilter = String(search.get("filter.p.product_type") || "").toLowerCase();
    if (pathname.indexOf("/collections/motorcycle") === 0) return true;
    if ((pathname === "/collections" || pathname.indexOf("/collections/all") === 0) && typeFilter === "motorcycle") {
      return true;
    }
    return false;
  }

  function withPreviewParams(url) {
    if (!url) return url;
    try {
      var current = new URL(window.location.href);
      var target = new URL(url, current.origin);
      ["preview_theme_id", "_fd", "pb"].forEach(function (key) {
        var value = current.searchParams.get(key);
        if (value && !target.searchParams.has(key)) {
          target.searchParams.set(key, value);
        }
      });
      return target.toString();
    } catch (error) {
      return url;
    }
  }

  function escapeTopNavigation(url) {
    if (!url) return;
    var resolvedUrl = withPreviewParams(url);
    try {
      if (window.top && window.top !== window.self) {
        window.top.location.href = resolvedUrl;
        return;
      }
    } catch (error) {
      /* no-op */
    }
    window.location.href = resolvedUrl;
  }

  function bindTopNavigation() {
    document.addEventListener("click", function (event) {
      var link = event.target.closest("[data-open-top]");
      if (!link) return;
      if (link.closest("[data-drawer]")) return;
      event.preventDefault();
      escapeTopNavigation(link.href);
    });

    document.addEventListener("submit", function (event) {
      var form = event.target.closest("[data-open-top-form]");
      if (!form) return;
      if (form.closest("[data-drawer]")) return;
      event.preventDefault();
      var formData = new FormData(form);
      var query = new URLSearchParams(formData);
      var action = form.getAttribute("action") || "/search";
      escapeTopNavigation(action + "?" + query.toString());
    });
  }

  var prefetchedDocuments = {};

  function prefetchDocument(url) {
    if (!url || prefetchedDocuments[url]) return;
    try {
      var target = new URL(url, window.location.origin);
      if (target.origin !== window.location.origin) return;
      prefetchedDocuments[target.href] = true;
      var hint = document.createElement("link");
      hint.rel = "prefetch";
      hint.as = "document";
      hint.href = target.href;
      document.head.appendChild(hint);
    } catch (error) {
      /* no-op */
    }
  }

  function bindFastProductLinks() {
    var selector = "[data-fast-product-link]";

    document.addEventListener("mouseover", function (event) {
      var link = event.target.closest(selector);
      if (!link) return;
      prefetchDocument(link.href);
    }, { passive: true });

    document.addEventListener("focusin", function (event) {
      var link = event.target.closest(selector);
      if (!link) return;
      prefetchDocument(link.href);
    });

    document.addEventListener("touchstart", function (event) {
      var link = event.target.closest(selector);
      if (!link) return;
      prefetchDocument(link.href);
    }, { passive: true });

    document.addEventListener("mousedown", function (event) {
      if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      var link = event.target.closest(selector);
      if (!link || !link.href) return;
      event.preventDefault();
      window.location.assign(link.href);
    });
  }

  function formatCents(cents, currencyCode) {
    var amount = (Number(cents) || 0) / 100;
    try {
      return new Intl.NumberFormat(undefined, {
        style: "currency",
        currency: currencyCode || "USD",
        maximumFractionDigits: 2
      }).format(amount);
    } catch (error) {
      return amount.toFixed(2);
    }
  }

  function refreshCartBadge() {
    fetch("/cart.js", { credentials: "same-origin" })
      .then(function (response) { return response.ok ? response.json() : null; })
      .then(function (data) {
        if (!data) return;
        document.querySelectorAll("[data-cart-count]").forEach(function (node) {
          node.textContent = data.item_count > 0 ? String(data.item_count) : "";
        });
      })
      .catch(function () {
        /* local preview or unauthenticated theme editor */
      });
  }

  function bindReveal() {
    var nodes = document.querySelectorAll(".reveal");
    if (!nodes.length) return;

    if (!("IntersectionObserver" in window)) {
      nodes.forEach(function (node) { node.classList.add("is-visible"); });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-visible");
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.2 });

    nodes.forEach(function (node) {
      if (node.classList.contains("is-visible")) return;
      observer.observe(node);
    });
  }

  function bindHeader() {
    var header = document.querySelector("[data-site-header]");
    if (!header) return;
    body.classList.add("has-site-header");

    function forceAboutUsLabel() {
      var links = document.querySelectorAll('a.nav-trigger[href="/pages/dealer-network"], a.nav-trigger[href="/pages/about-us"], .nav-drawer__links a[href="/pages/dealer-network"], .nav-drawer__links a[href="/pages/about-us"]');
      links.forEach(function (link) {
        link.textContent = "About Us";
      });

      var headings = document.querySelectorAll(".nav-drawer__section > h3");
      headings.forEach(function (heading) {
        if (heading.textContent && heading.textContent.trim() === "Dealer Network") {
          heading.textContent = "About Us";
        }
      });
    }

    forceAboutUsLabel();

    function syncHeaderHeight() {
      var height = header.offsetHeight || 60;
      document.documentElement.style.setProperty("--nav-height", height + "px");
    }

    syncHeaderHeight();
    window.addEventListener("resize", syncHeaderHeight);

    var megaNav = header.querySelector("[data-mega-nav]");
    var menuButtons = header.querySelectorAll("[data-nav-menu]");
    var panels = header.querySelectorAll("[data-menu-panel]");
    var drawer = document.querySelector("[data-drawer]");
    var drawerToggle = header.querySelector("[data-drawer-toggle]");
    var drawerClose = document.querySelector("[data-drawer-close]");

    var activeMenu = "";
    var raf = window.requestAnimationFrame || function (cb) { return setTimeout(cb, 16); };

    function refreshCarousels() {
      header.querySelectorAll("[data-carousel]").forEach(function (carousel) {
        if (typeof carousel.__syncButtons === "function") {
          carousel.__syncButtons();
        }
      });
    }

    function syncMenuState() {
      menuButtons.forEach(function (button) {
        var isActive = button.getAttribute("data-nav-menu") === activeMenu;
        var pageActive = button.getAttribute("data-page-active") === "true";
        button.classList.toggle("is-active", isActive || (!activeMenu && pageActive));
        button.setAttribute("aria-expanded", isActive ? "true" : "false");
      });

      panels.forEach(function (panel) {
        var shouldShow = panel.getAttribute("data-menu-panel") === activeMenu;
        panel.hidden = !shouldShow;
      });

      header.classList.toggle("is-open", Boolean(activeMenu));
      if (megaNav) {
        megaNav.setAttribute("aria-hidden", activeMenu ? "false" : "true");
      }
      raf(refreshCarousels);
    }

    function closeMenu() {
      activeMenu = "";
      syncMenuState();
    }

    function openMenu(menuKey) {
      activeMenu = menuKey;
      syncMenuState();
    }

    menuButtons.forEach(function (button) {
      button.addEventListener("click", function () {
        var menuKey = button.getAttribute("data-nav-menu");
        if (!menuKey) return;
        if (activeMenu === menuKey) {
          closeMenu();
        } else {
          openMenu(menuKey);
        }
      });
    });

    document.addEventListener("click", function (event) {
      if (!header.contains(event.target)) {
        closeMenu();
      }
    });

    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape") {
        closeMenu();
        if (drawer) {
          drawer.classList.remove("is-open");
          drawer.setAttribute("aria-hidden", "true");
        }
      }
    });

    if (drawer && drawerToggle) {
      drawerToggle.addEventListener("click", function () {
        var willOpen = !drawer.classList.contains("is-open");
        drawer.classList.toggle("is-open", willOpen);
        drawer.setAttribute("aria-hidden", willOpen ? "false" : "true");
        drawerToggle.setAttribute("aria-expanded", willOpen ? "true" : "false");
        body.style.overflow = willOpen ? "hidden" : "";
      });
    }

    if (drawer && drawerClose) {
      drawerClose.addEventListener("click", function () {
        drawer.classList.remove("is-open");
        drawer.setAttribute("aria-hidden", "true");
        if (drawerToggle) drawerToggle.setAttribute("aria-expanded", "false");
        body.style.overflow = "";
      });
    }

    if (drawer) {
      drawer.querySelectorAll("a[data-open-top]").forEach(function (link) {
        link.addEventListener("click", function () {
          drawer.classList.remove("is-open");
          drawer.setAttribute("aria-hidden", "true");
          if (drawerToggle) drawerToggle.setAttribute("aria-expanded", "false");
          body.style.overflow = "";
        });
      });

      drawer.querySelectorAll("form[data-open-top-form]").forEach(function (form) {
        form.addEventListener("submit", function () {
          drawer.classList.remove("is-open");
          drawer.setAttribute("aria-hidden", "true");
          if (drawerToggle) drawerToggle.setAttribute("aria-expanded", "false");
          body.style.overflow = "";
        });
      });
    }

    if (drawer) {
      drawer.addEventListener("click", function (event) {
        if (event.target === drawer) {
          drawer.classList.remove("is-open");
          drawer.setAttribute("aria-hidden", "true");
          if (drawerToggle) drawerToggle.setAttribute("aria-expanded", "false");
          body.style.overflow = "";
        }
      });
    }

    header.querySelectorAll("[data-carousel]").forEach(function (carousel) {
      var track = carousel.querySelector("[data-carousel-track]");
      var prev = carousel.querySelector("[data-carousel-prev]");
      var next = carousel.querySelector("[data-carousel-next]");
      if (!track || !prev || !next) return;

      function step() {
        var firstCard = track.querySelector(".mega-nav__product");
        var gap = parseFloat(getComputedStyle(track).gap || "16") || 16;
        return firstCard ? firstCard.getBoundingClientRect().width + gap : track.clientWidth * 0.75;
      }

      function syncButtons() {
        var maxScroll = Math.max(track.scrollWidth - track.clientWidth, 0);
        prev.disabled = track.scrollLeft <= 4;
        next.disabled = track.scrollLeft >= maxScroll - 4;
      }

      prev.addEventListener("click", function () {
        track.scrollBy({ left: step() * -1, behavior: "smooth" });
      });

      next.addEventListener("click", function () {
        track.scrollBy({ left: step(), behavior: "smooth" });
      });

      track.addEventListener("scroll", syncButtons, { passive: true });
      window.addEventListener("resize", syncButtons);
      carousel.__syncButtons = syncButtons;
      syncButtons();
    });
  }

  function bindQuickView() {
    var modal = document.querySelector("[data-qv-modal]");
    if (!modal) return;

    var imageNode = modal.querySelector("[data-qv-image]");
    var thumbsNode = modal.querySelector("[data-qv-thumbs]");
    var metaNode = modal.querySelector("[data-qv-meta]");
    var titleNode = modal.querySelector("[data-qv-title]");
    var priceNode = modal.querySelector("[data-qv-price]");
    var summaryNode = modal.querySelector("[data-qv-summary]");
    var purchaseNode = modal.querySelector("[data-qv-purchase]");
    var purchaseHint = modal.querySelector("[data-qv-purchase-hint]");
    var variantNode = modal.querySelector("[data-qv-variant-id]");
    var qtyInput = modal.querySelector("[data-qv-qty-input]");
    var qtyForm = modal.querySelector("[data-qv-qty-form]");
    var qtyMinus = modal.querySelector("[data-qv-qty-minus]");
    var qtyPlus = modal.querySelector("[data-qv-qty-plus]");
    var addCartBtn = modal.querySelector("[data-qv-add-cart]");
    var buyNowBtn = modal.querySelector("[data-qv-buy-now]");
    var linkNode = modal.querySelector("[data-qv-link]");
    var dismissButtons = modal.querySelectorAll("[data-qv-close], [data-qv-dismiss]");
    var featuresNode = modal.querySelector("[data-qv-features]");
    var fullTitleNode = modal.querySelector("[data-qv-full-title]");
    var fullDetailsNode = modal.querySelector("[data-qv-full-details]");
    var formNode = modal.querySelector("[data-qv-cart-form]");

    var currentData = null;
    var currentImages = [];
    var modalCopy = {
      defaultLinkLabel: modal.dataset.qvDefaultLinkLabel || "Official Product Page",
      productFullTitle: modal.dataset.qvProductFullTitle || "Accessory Full Details",
      infoFullTitle: modal.dataset.qvInfoFullTitle || "Full Details",
      hintProductReady: modal.dataset.qvHintProductReady || "Add to cart and Buy Now are ready in Quick View.",
      hintInfoOnly: modal.dataset.qvHintInfoOnly || "This card is informational. Purchase is not available in Quick View.",
      hintAdding: modal.dataset.qvHintAdding || "Adding to cart...",
      hintAdded: modal.dataset.qvHintAdded || "Added to cart.",
      hintFailed: modal.dataset.qvHintFailed || "Unable to add to cart in this preview context."
    };

    function renderThumbnails(images) {
      if (!thumbsNode) return;
      thumbsNode.innerHTML = "";
      currentImages = images || [];

      currentImages.forEach(function (imageUrl, index) {
        if (!imageUrl) return;
        var button = document.createElement("button");
        button.type = "button";
        button.className = "modal-thumb" + (index === 0 ? " is-active" : "");
        button.dataset.index = String(index);

        var image = document.createElement("img");
        image.src = imageUrl;
        image.alt = currentData && currentData.title ? currentData.title : "Preview";
        button.appendChild(image);
        thumbsNode.appendChild(button);
      });
    }

    function setHeroImage(imageUrl) {
      if (!imageNode) return;
      imageNode.src = imageUrl || "";
      imageNode.alt = currentData && currentData.title ? currentData.title : "";
    }

    function buildMetaPills(data) {
      if (!metaNode) return;
      metaNode.innerHTML = "";
      [data.vendor, data.type, data.status, data.handle].forEach(function (value) {
        if (!value) return;
        var span = document.createElement("span");
        span.className = "modal-pill";
        span.textContent = value;
        metaNode.appendChild(span);
      });
    }

    function buildFeatures(items) {
      if (!featuresNode) return;
      featuresNode.innerHTML = "";
      var normalized = Array.isArray(items) ? items.filter(Boolean) : [];
      featuresNode.hidden = normalized.length === 0;
      normalized.forEach(function (item) {
        var li = document.createElement("li");
        li.textContent = item;
        featuresNode.appendChild(li);
      });
    }

    function syncQty() {
      var qty = sanitizeQty(qtyInput.value);
      qtyInput.value = String(qty);
      if (qtyForm) qtyForm.value = String(qty);
      return qty;
    }

    function openModal(trigger) {
      var dataNode = trigger.querySelector(".qv-data");
      var fullNode = trigger.querySelector(".qv-full-details");
      var data = parseJsonScript(dataNode);
      if (!data) return;

      currentData = data;
      var typeNormalized = String(data.type || "").toLowerCase();
      var isSupportImageOnly = data.mode !== "product" && typeNormalized === "support";
      modal.classList.toggle("is-support-image-only", isSupportImageOnly);

      titleNode.textContent = data.title || "";
      summaryNode.textContent = data.summary || "";
      priceNode.textContent = data.priceText || "";
      priceNode.hidden = !data.priceText;
      summaryNode.hidden = !data.summary;

      buildMetaPills(data);
      buildFeatures(data.features);

      fullTitleNode.textContent = data.mode === "product" ? modalCopy.productFullTitle : (data.type || modalCopy.infoFullTitle);
      fullDetailsNode.innerHTML = fullNode ? fullNode.innerHTML : "";

      var images = Array.isArray(data.images) && data.images.length ? data.images : [data.image].filter(Boolean);
      renderThumbnails(images);
      setHeroImage(images[0] || data.image || "");

      qtyInput.value = "1";
      syncQty();

      var isProduct = data.mode === "product";
      purchaseNode.hidden = !isProduct;
      if (variantNode) {
        variantNode.value = data.variantId || "";
      }

      if (purchaseHint) {
        purchaseHint.textContent = isProduct
          ? modalCopy.hintProductReady
          : modalCopy.hintInfoOnly;
      }

      linkNode.hidden = !data.productUrl;
      if (data.productUrl) {
        linkNode.href = data.productUrl;
        linkNode.textContent = data.linkLabel || modalCopy.defaultLinkLabel;
      }

      if (buyNowBtn) {
        if (isProduct && data.variantId) {
          buyNowBtn.hidden = false;
        } else {
          buyNowBtn.hidden = true;
        }
      }

      modal.hidden = false;
      modal.classList.add("is-open");
      body.style.overflow = "hidden";
    }

    function closeModal() {
      modal.hidden = true;
      modal.classList.remove("is-open");
      modal.classList.remove("is-support-image-only");
      body.style.overflow = "";
    }

    document.addEventListener("click", function (event) {
      var trigger = event.target.closest("[data-qv-trigger]");
      if (trigger) {
        var inMotorcyclePanel = trigger.closest('.mega-nav__panel[data-menu="Motorcycle"]');
        var onMotorcycleCollectionPage = isMotorcycleCollectionContext()
          && !!trigger.closest(".catalog-card__preview");

        if (inMotorcyclePanel || onMotorcycleCollectionPage) {
          var redirectData = parseJsonScript(trigger.querySelector(".qv-data"));
          if (redirectData && redirectData.productUrl) {
            event.preventDefault();
            escapeTopNavigation(String(redirectData.productUrl));
            return;
          }
        }

        event.preventDefault();
        openModal(trigger);
        return;
      }

      var thumb = event.target.closest(".modal-thumb");
      if (thumb) {
        var index = parseInt(thumb.dataset.index || "0", 10);
        setHeroImage(currentImages[index] || currentImages[0] || "");
        thumbsNode.querySelectorAll(".modal-thumb").forEach(function (node, thumbIndex) {
          node.classList.toggle("is-active", thumbIndex === index);
        });
      }
    });

    dismissButtons.forEach(function (button) {
      button.addEventListener("click", function () {
        closeModal();
      });
    });

    modal.addEventListener("click", function (event) {
      if (event.target === modal) closeModal();
    });

    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape" && modal.classList.contains("is-open")) {
        closeModal();
      }
    });

    qtyMinus.addEventListener("click", function () {
      qtyInput.value = String(Math.max(1, sanitizeQty(qtyInput.value) - 1));
      syncQty();
    });

    qtyPlus.addEventListener("click", function () {
      qtyInput.value = String(Math.min(99, sanitizeQty(qtyInput.value) + 1));
      syncQty();
    });

    qtyInput.addEventListener("input", syncQty);
    qtyInput.addEventListener("change", syncQty);

    if (formNode) {
      formNode.addEventListener("submit", function (event) {
        event.preventDefault();
        if (!currentData || !currentData.variantId) return;

        var qty = syncQty();
        addCartBtn.disabled = true;
        if (purchaseHint) purchaseHint.textContent = modalCopy.hintAdding;

        fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
          },
          credentials: "same-origin",
          body: JSON.stringify({
            id: currentData.variantId,
            quantity: qty
          })
        })
          .then(function (response) {
            return response.ok ? response.json() : Promise.reject(new Error("Failed to add to cart"));
          })
          .then(function () {
            if (purchaseHint) purchaseHint.textContent = modalCopy.hintAdded;
            refreshCartBadge();
          })
          .catch(function () {
            if (purchaseHint) purchaseHint.textContent = modalCopy.hintFailed;
          })
          .finally(function () {
            addCartBtn.disabled = false;
          });
      });
    }

    if (buyNowBtn) {
      buyNowBtn.addEventListener("click", function (event) {
        event.preventDefault();
        if (!currentData) return;
        if (currentData.variantId) {
          var qty = syncQty();
          escapeTopNavigation("/cart/" + currentData.variantId + ":" + qty + "?checkout");
          return;
        }
        if (currentData.productUrl) {
          escapeTopNavigation(currentData.productUrl);
        }
      });
    }

    if (linkNode) {
      linkNode.addEventListener("click", function (event) {
        if (linkNode.hidden || !linkNode.href) {
          event.preventDefault();
          return;
        }
        closeModal();
      });
    }
  }

  function bindCatalogCardAddToCart() {
    document.addEventListener("click", function (event) {
      var actionButton = event.target.closest('.catalog-card__purchase-form button[type="submit"]');
      if (!actionButton) return;
      var form = actionButton.closest(".catalog-card__purchase-form");
      if (!form) return;

      event.preventDefault();
      var idInput = form.querySelector('input[name="id"]');
      if (!idInput || !idInput.value) return;

      if (actionButton.matches("[data-catalog-buy-now]")) {
        escapeTopNavigation("/cart/" + String(idInput.value).trim() + ":1?checkout");
        return;
      }

      if (!actionButton.matches("[data-catalog-add-to-cart]")) return;

      var addButton = actionButton;
      addButton.disabled = true;

      fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json"
        },
        credentials: "same-origin",
        body: JSON.stringify({
          id: idInput.value,
          quantity: 1
        })
      })
        .then(function (response) {
          return response.ok ? response.json() : Promise.reject(new Error("Unable to add product"));
        })
        .then(function () {
          refreshCartBadge();
        })
        .catch(function () {
          /* keep page stable in preview contexts */
        })
        .finally(function () {
          addButton.disabled = false;
        });
    });
  }

  function bindProductStoryAddToCart() {
    var forms = document.querySelectorAll(".product-buy-form");
    if (!forms.length) return;

    forms.forEach(function (form) {
      var addButton = form.querySelector("[data-product-add-to-cart]");
      var checkoutButton = form.querySelector("[data-product-buy-now]");
      if (!addButton) return;

      var getVariantId = function () {
        var idInput = form.querySelector('[name="id"]');
        return idInput ? String(idInput.value || "").trim() : "";
      };

      var getQuantity = function () {
        var qtyInput = form.querySelector('[name="quantity"]');
        return qtyInput ? sanitizeQty(qtyInput.value) : 1;
      };

      var submitAddToCart = function (event) {
        if (event) event.preventDefault();
        var variantId = getVariantId();
        var quantity = getQuantity();
        if (!variantId) return;

        addButton.disabled = true;

        fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
          },
          credentials: "same-origin",
          body: JSON.stringify({
            id: variantId,
            quantity: quantity
          })
        })
          .then(function (response) {
            return response.ok ? response.json() : Promise.reject(new Error("Unable to add product"));
          })
          .then(function () {
            refreshCartBadge();
          })
          .catch(function () {
            /* keep page stable; cart icon count will remain as last known value */
          })
          .finally(function () {
            addButton.disabled = false;
          });
      };

      var submitBuyNow = function (event) {
        if (event) event.preventDefault();
        var variantId = getVariantId();
        var quantity = getQuantity();
        if (!variantId) return;
        escapeTopNavigation("/cart/" + variantId + ":" + quantity + "?checkout");
      };

      addButton.addEventListener("click", submitAddToCart);
      if (checkoutButton) {
        checkoutButton.addEventListener("click", submitBuyNow);
      }

      form.addEventListener("submit", function (event) {
        var submitter = event.submitter || document.activeElement;
        if (checkoutButton && submitter === checkoutButton) {
          submitBuyNow(event);
          return;
        }
        if (submitter && submitter !== addButton) {
          return;
        }
        submitAddToCart(event);
      });
    });
  }

  function normalizeAboutUsLabel() {
    var links = document.querySelectorAll('a.nav-trigger[href="/pages/dealer-network"], a.nav-trigger[href="/pages/about-us"], .nav-drawer__links a[href="/pages/dealer-network"], .nav-drawer__links a[href="/pages/about-us"]');
    links.forEach(function (link) {
      link.textContent = "About Us";
    });

    var headings = document.querySelectorAll(".nav-drawer__section > h3");
    headings.forEach(function (heading) {
      if (heading.textContent && heading.textContent.trim() === "Dealer Network") {
        heading.textContent = "About Us";
      }
    });
  }

  function parseQuickViewProductUrl(trigger) {
    if (!trigger) return "";
    var dataNode = trigger.querySelector(".qv-data");
    var data = parseJsonScript(dataNode);
    if (!data || !data.productUrl) return "";
    return String(data.productUrl || "");
  }

  function bindMotorcycleQuickViewRedirect() {
    document.addEventListener("click", function (event) {
      var trigger = event.target.closest("[data-qv-trigger]");
      if (!trigger) return;

      var inMotorcyclePanel = trigger.closest('.mega-nav__panel[data-menu="Motorcycle"]');
      var onMotorcycleCollectionPage = isMotorcycleCollectionContext()
        && !!trigger.closest(".catalog-card__preview");

      if (!inMotorcyclePanel && !onMotorcycleCollectionPage) return;

      var productUrl = parseQuickViewProductUrl(trigger);
      if (!productUrl) return;

      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === "function") {
        event.stopImmediatePropagation();
      }
      escapeTopNavigation(productUrl);
    }, true);
  }

  function bindUtilityModal() {
    var modal = document.querySelector("[data-utility-modal]");
    if (!modal) return;

    var closeButton = modal.querySelector("[data-utility-close]");
    var views = modal.querySelectorAll("[data-utility-view]");
    var cartList = modal.querySelector("[data-utility-cart-list]");
    var cartSubtotal = modal.querySelector("[data-utility-cart-subtotal]");
    var searchForm = modal.querySelector("[data-utility-search-form]");
    var searchResults = modal.querySelector("[data-utility-search-results]");

    function renderSearchResults(products, query) {
      if (!searchResults) return;

      if (!products || !products.length) {
        searchResults.innerHTML = '<div class="utility-search-results__empty">' + i18n("search_no_result", 'No result for "{{query}}".').replace("{{query}}", query) + "</div>";
        return;
      }

      var html = products.map(function (product) {
        var image = product.image ? '<img src="' + product.image + '" alt="' + (product.title || i18n("search_untitled", "Untitled")) + '">' : '<div class="utility-search-results__no-image">' + i18n("search_no_image", "No image") + "</div>";
        return [
          '<a class="utility-search-results__item" href="' + (product.url || "#") + '" data-open-top>',
          '<div class="utility-search-results__media">',
          image,
          "</div>",
          '<div class="utility-search-results__copy">',
          '<div class="utility-search-results__title">' + (product.title || i18n("search_untitled", "Untitled")) + "</div>",
          '<div class="utility-search-results__meta">' + (product.vendor || i18n("search_vendor_fallback", "BEGODE")) + "</div>",
          "</div>",
          "</a>"
        ].join("");
      }).join("");

      searchResults.innerHTML = html;
    }

    function setView(viewKey) {
      views.forEach(function (viewNode) {
        viewNode.hidden = viewNode.getAttribute("data-utility-view") !== viewKey;
      });
    }

    function renderCart() {
      if (!cartList) return;
      cartList.innerHTML = i18n("cart_loading", "Loading cart...");
      fetch("/cart.js", { credentials: "same-origin" })
        .then(function (response) { return response.ok ? response.json() : null; })
        .then(function (cart) {
          if (!cart) throw new Error("Unable to read cart");
          if (!cart.items || !cart.items.length) {
            cartList.innerHTML = '<p class="utility-cart__price">' + i18n("cart_empty", "Your cart is empty.") + "</p>";
            if (cartSubtotal) {
              cartSubtotal.textContent = i18n("cart_subtotal", "Subtotal: {{amount}}").replace("{{amount}}", formatCents(0, cart.currency));
            }
            return;
          }

          var html = cart.items.map(function (item) {
            var image = item.image ? '<img src="' + item.image + '" alt="' + (item.product_title || i18n("cart_item_fallback", "Item")) + '">' : '<div class="utility-cart__placeholder"></div>';
            return [
              '<div class="utility-cart__item">',
              image,
              '<div>',
              '<div class="utility-cart__name">' + (item.product_title || i18n("cart_item_fallback", "Item")) + '</div>',
              '<div class="utility-cart__qty-controls">',
              '<button type="button" class="utility-cart__qty-btn" data-cart-change data-cart-key="' + item.key + '" data-cart-qty="' + Math.max(0, item.quantity - 1) + '">-</button>',
              '<span class="utility-cart__qty-value">' + item.quantity + "</span>",
              '<button type="button" class="utility-cart__qty-btn" data-cart-change data-cart-key="' + item.key + '" data-cart-qty="' + (item.quantity + 1) + '">+</button>',
              '<button type="button" class="utility-cart__remove" data-cart-change data-cart-key="' + item.key + '" data-cart-qty="0">' + i18n("cart_delete", "Delete") + "</button>",
              "</div>",
              "</div>",
              '<div class="utility-cart__price">' + formatCents(item.final_line_price || 0, cart.currency) + "</div>",
              "</div>"
            ].join("");
          }).join("");
          cartList.innerHTML = html;
          if (cartSubtotal) {
            cartSubtotal.textContent = i18n("cart_subtotal", "Subtotal: {{amount}}").replace("{{amount}}", formatCents(cart.total_price || 0, cart.currency));
          }
          refreshCartBadge();
        })
        .catch(function () {
          cartList.innerHTML = '<p class="utility-cart__price">' + i18n("cart_unavailable", "Unable to load cart in this preview context.") + "</p>";
          if (cartSubtotal) {
            cartSubtotal.textContent = "";
          }
        });
    }

    function openModal(viewKey) {
      setView(viewKey);
      if (viewKey === "cart") {
        renderCart();
      }
      if (viewKey === "search" && searchResults) {
        searchResults.innerHTML = '<div class="utility-search-results__empty">' + i18n("search_prompt", "Search products and parts in this window.") + "</div>";
      }
      modal.hidden = false;
      body.style.overflow = "hidden";
    }

    function closeModal() {
      modal.hidden = true;
      body.style.overflow = "";
    }

    document.addEventListener("click", function (event) {
      var trigger = event.target.closest("[data-utility-open]");
      if (trigger) {
        event.preventDefault();
        var viewKey = trigger.getAttribute("data-utility-open");
        openModal(viewKey || "search");
        return;
      }

      if (closeButton && event.target === closeButton) {
        closeModal();
        return;
      }

      if (event.target === modal) {
        closeModal();
        return;
      }

      var cartChangeButton = event.target.closest("[data-cart-change]");
      if (cartChangeButton) {
        event.preventDefault();
        var key = cartChangeButton.getAttribute("data-cart-key");
        var nextQty = parseInt(cartChangeButton.getAttribute("data-cart-qty") || "0", 10);
        if (!key || !Number.isFinite(nextQty)) return;
        cartChangeButton.disabled = true;

        fetch("/cart/change.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
          },
          credentials: "same-origin",
          body: JSON.stringify({
            id: key,
            quantity: Math.max(0, nextQty)
          })
        })
          .then(function (response) {
            return response.ok ? response.json() : Promise.reject(new Error("cart change failed"));
          })
          .then(function () {
            renderCart();
            refreshCartBadge();
          })
          .catch(function () {
            renderCart();
          })
          .finally(function () {
            cartChangeButton.disabled = false;
          });
      }
    });

    if (closeButton) {
      closeButton.addEventListener("click", closeModal);
    }

    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape" && !modal.hidden) {
        closeModal();
      }
    });

    if (searchForm) {
      searchForm.addEventListener("submit", function (event) {
        event.preventDefault();
        var input = searchForm.querySelector('input[name="q"]');
        var query = input ? String(input.value || "").trim() : "";
        if (!query) return;
        if (searchResults) {
          searchResults.innerHTML = '<div class="utility-search-results__empty">' + i18n("search_searching", "Searching...") + "</div>";
        }

        var params = new URLSearchParams();
        params.set("q", query);
        params.set("resources[type]", "product");
        params.set("resources[limit]", "12");
        params.set("resources[options][unavailable_products]", "last");

        fetch("/search/suggest.json?" + params.toString(), {
          credentials: "same-origin",
          headers: { "Accept": "application/json" }
        })
          .then(function (response) {
            return response.ok ? response.json() : Promise.reject(new Error("search failed"));
          })
          .then(function (payload) {
            var products = payload && payload.resources && payload.resources.results && payload.resources.results.products
              ? payload.resources.results.products
              : [];
            renderSearchResults(products, query);
          })
          .catch(function () {
            if (searchResults) {
              searchResults.innerHTML = '<div class="utility-search-results__empty">' + i18n("search_unavailable", "Search is unavailable in this preview context.") + "</div>";
            }
          });
      });
    }
  }

  bindTopNavigation();
  bindFastProductLinks();
  normalizeAboutUsLabel();
  bindHeader();
  bindMotorcycleQuickViewRedirect();
  bindQuickView();
  bindCatalogCardAddToCart();
  bindProductStoryAddToCart();
  bindUtilityModal();
  bindReveal();
  refreshCartBadge();
})();
